module.exports = __webpack_public_path__ + "img/role6.42f1602d.jpg";